/**
 * Define exam question mixin
 *
 * @author minkyoung.park@emcast.com
 */
const LINE_FEED = 10;

export const questionMixin = {

    data() {
        return {
            solveTimer: null,
            solveTime: 0,
            startDate: null,
            maxLength: 1000
        }
    },

    mounted() {
        this.startDate = Date.now()
    },

    methods: {
        // start timer
        startTimer() {
            this.solveTimer = setInterval( () => {
                this.solveTime += 1
            }
            , 1000)
        },

        // clear timer
        clearTimer() {
            clearInterval(this.solveTimer)
        },

        // check correct
        isCorrect() {
            return this.question.correct
        },

        stopKeyPress(e) {
            e.preventDefault();
            e.stopPropagation();
            e.keyCode = 0;
            e.returnValue = false;
            return false;
        },

        limitBytes(e) {
            const textCount = this.getByte(this.text) <= this.maxLength;
            if(textCount) {
                return this.stopKeyPress(e);
            }
            this.text = textCount ? this.text : this.getLimitedByteText(this.text, this.maxLength) // value를 100바이트까지 계산해 잘린 값
        },

        getByteLength(decimal) {
            return (decimal >> 7) || (LINE_FEED === decimal) ? 2 : 1
        },

        getByte(str) {
            return str.split('').map((s) => s.charCodeAt(0)).reduce((prev, unicodeDecimalValue) => prev + this.getByteLength(unicodeDecimalValue), 0)
        },

        getLimitedByteText(inputText, maxByte) {
            const characters = inputText.split('')
            let validText = ''
            let totalByte = 0

            for (let i = 0; i < characters.length; i += 1) {
                const character = characters[i]
                const decimal = character.charCodeAt(0)
                const byte = this.getByteLength(decimal) // 글자 한 개가 몇 바이트 길이인지 구해주기

                // 현재까지의 바이트 길이와 더해 최대 바이트 길이를 넘지 않으면
                if (totalByte + byte <= maxByte) {
                    totalByte += byte      // 바이트 길이 값을 더해 현재까지의 총 바이트 길이 값을 구함
                    validText += character // 글자를 더해 현재까지의 총 문자열 값을 구함
                } else {                 // 최대 바이트 길이를 넘으면
                    document.addEventListener('keydown', this.stopKeyPress);
                    break;
                }
            }
            document.removeEventListener('keydown', this.stopKeyPress);
            return validText
        },
    }
}
